import * as Analytics from "firebase/analytics";
import { initializeApp } from "firebase/app";
import ReactPixel from "react-facebook-pixel";

import { WEB_ANALITYCS_API_KEY } from "@/config/enviroment";

import { AnalyticsEvents } from "./types";

const config = {
  apiKey: WEB_ANALITYCS_API_KEY,
  authDomain: "ifeira-backup.firebaseapp.com",
  databaseURL: "https://ifeira-backup.firebaseio.com",
  projectId: "ifeira-backup",
  storageBucket: "ifeira-backup.appspot.com",
  messagingSenderId: "402475332703",
  appId: "1:402475332703:web:042da491081c2fa5b8d7ea",
  measurementId: "G-PQ49ZE20G1",
};

const firebaseApp = initializeApp(config);
const analytics = Analytics.getAnalytics(firebaseApp);

const options = {
  autoConfig: true,
  debug: false,
};

ReactPixel.init("3648038028764514", null, options);

const events: AnalyticsEvents = {
  logEvent(eventName, eventProps = null) {
    try {
      if (eventProps) {
        ReactPixel.trackCustom(eventName, eventProps);
        Analytics.logEvent(analytics, eventName, eventProps);
      } else {
        ReactPixel.trackCustom(eventName);
        Analytics.logEvent(analytics, eventName);
      }
    } catch (error) {
      console.error(error);
    }
  },
  logFirebaseScreenView(screen) {
    Analytics.logEvent(analytics, "screen_view", {
      firebase_screen: screen,
      firebase_screen_class: screen,
    });
  },
  logFirebasePurchase(total, coupon) {
    Analytics.logEvent(analytics, "purchase" as never, {
      value: total,
      currency: "BRL",
      coupon,
    });
  },
  logFacebookPurchase(total) {
    ReactPixel.track("Purchase", { currency: "BRL", value: total });
  },
};

export default events;
